/**
 * @author pjh
 * @date 2025.09.02
 * @description 폰트 미리보기 컴포넌트
 */

import React, { useEffect, useRef } from 'react';
import { applyFontToElement } from '../../../util/fontUtils';

interface IFontPreview {
    fontName: string;
    fontSize?: number;
    color?: string;
    style?: React.CSSProperties;
}

const FontPreview: React.FC<IFontPreview> = ({
    fontName,
    fontSize = 24,
    color = '#1f2937',
    style = {}
}) => {
    const previewRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (previewRef.current) {
            applyFontToElement(previewRef.current, fontName);
        }
    }, [fontName]);

    return (
        <div
            ref={previewRef}
            style={{
                fontSize: `${fontSize}px`,
                color,
                textAlign: 'center',
                lineHeight: 1.5,
                ...style
            }}
        >
            <div>가나다</div>
            <div style={{ fontSize: `${fontSize - 4}px`, marginTop: '8px' }}>ABC 123</div>
        </div>
    );
};

export default FontPreview;